var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFaq1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arbitration_FAQs",
    "data-name": "Arbitration FAQs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.943,
    height: 74.943,
    viewBox: "0 0 74.943 74.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 36.972,
    cy: 36.972,
    r: 36.972,
    transform: "translate(0.5 0.5)",
    fill: "#003e7f",
    stroke: "#fff",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M29.5,15.756a.63.63,0,0,0-.589-.06,4.226,4.226,0,0,1-3.19,0,.629.629,0,0,0-.867.583v28H19.751a2.5,2.5,0,0,0-2.492,2.492v1.865a.629.629,0,0,0,.629.629H36.757a.629.629,0,0,0,.629-.629V46.768a2.5,2.5,0,0,0-2.492-2.492H29.787v-28a.645.645,0,0,0-.282-.522Zm-3.389,1.375a5.582,5.582,0,0,0,2.41,0V44.276h-2.41ZM36.126,46.768V48H18.516V46.768a1.237,1.237,0,0,1,1.236-1.236H34.892a1.237,1.237,0,0,1,1.234,1.236ZM50.888,29.814H49.616l-5-14.447h.512a.629.629,0,0,0,.629-.629V12.411h1.982a.629.629,0,1,0,0-1.258l-16.764,0a3.707,3.707,0,0,0-7.307,0l-16.764,0a.629.629,0,0,0,0,1.258H8.885V14.74a.629.629,0,0,0,.629.629h.512l-5,14.445H3.754a.627.627,0,0,0-.629.627,7.785,7.785,0,0,0,15.57,0,.629.629,0,0,0-.629-.629H16.793l-5-14.445H12.3a.629.629,0,0,0,.629-.629V12.411H23.667a3.707,3.707,0,0,0,7.307,0H41.707v2.327a.629.629,0,0,0,.629.629h.512l-5,14.447H36.576a.629.629,0,0,0-.629.629,7.785,7.785,0,1,0,15.57,0,.627.627,0,0,0-.629-.627ZM10.91,36.97a6.538,6.538,0,0,1-6.5-5.9h13a6.54,6.54,0,0,1-6.5,5.9ZM6.357,29.814,10.91,16.66l4.553,13.154Zm5.319-15.705H10.144v-1.7h1.532Zm15.645.125a2.452,2.452,0,1,1,2.452-2.454A2.455,2.455,0,0,1,27.322,14.234ZM44.5,12.411v1.7H42.966v-1.7Zm-.766,4.248,4.553,13.154H39.179Zm0,20.311a6.538,6.538,0,0,1-6.5-5.9h13a6.54,6.54,0,0,1-6.5,5.9Zm-.321,13.757a.629.629,0,0,1-.629.629H11.858a.629.629,0,0,1,0-1.258H42.783A.629.629,0,0,1,43.412,50.728Z",
    transform: "translate(9.874 6.926)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq1);
export default __webpack_public_path__ + "static/media/icon-faq-1.3650fdfb4aff8b2f7028b5fe317163bc.svg";
export { ForwardRef as ReactComponent };